import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Dropdown, Counter, DotLoader } from '@myplay/ui';
import { inject, observer } from 'mobx-react';

import { ORANGE, ORANGE_LIGHT, GREEN_LIGHT } from '../../styles/colors';
import { capitalize, toTitleCase } from '../../utils/stringManipulations';
import { NAME } from '../../utils/constants';
import I18N from '../../I18N';
import closeIcon from '../../assets/icons/Icon-Close.svg';
import "./Record.scss";

const Record = ({ TeamsStore, onClose, SitesStore, site })=> {
  const { teams } = TeamsStore;
  const { isRecording, recordingTeam, timeToEndRecord } = site;
  const [ selectedTeam, setSelectedTeam ] = useState(null); 
  const [ recordLoader, setRecordLoader ] = useState(null);
  const [ error, setError ] = useState(null);

  const handleTeamSelect = team => {
    setSelectedTeam({ ...team });
    setError(null);
  }

  const handleRecord = async ()=> {
    const { startRecord } = SitesStore;
    setRecordLoader(true);
    await startRecord(selectedTeam._id);
    setRecordLoader(false);
  };

  const handleStop = async ()=> {
    const { stopRecord } = SitesStore;
    setRecordLoader(true);
    await stopRecord(recordingTeam);
    setRecordLoader(false);
  }

  return (
    <div className="record" data-testid="record">
      <button className="record__close-button" onClick={onClose}>
        <img src={closeIcon} alt=""/>
      </button>
      {recordLoader ?
        <DotLoader /> :
        <Fragment>
          {isRecording ? 
            <span className="record__title">{recordingTeam}</span> :
            <Dropdown 
              placeholder={toTitleCase(I18N.t("CHOOSE_TEAM"))} 
              items={teams} 
              displayedProperty={NAME}
              onSelect={handleTeamSelect}
            />
          }
          {isRecording ? 
            <button 
              className="record__record-button" 
              style={{ backgroundColor: GREEN_LIGHT }}
              onClick={handleStop}
            >
              {I18N.t("STOP").toUpperCase()}
            </button> :
            <button 
              className="record__record-button" 
              style={{ backgroundColor: selectedTeam ? ORANGE : ORANGE_LIGHT }}
              onClick={selectedTeam ? handleRecord : ()=>setError(capitalize(I18N.t("CHOOSE_TEAM_WARNING")))}
            >
              {I18N.t("REC").toUpperCase()}
            </button> 
          }
          {isRecording &&
            <Counter 
              className="record__counter"
              time={timeToEndRecord}
              hasHours
            />
          }
          <span className="record__error">{error || ""}</span>
        </Fragment>
      }
    </div>
  );
};

Record.propTypes = {
  onClose: PropTypes.func, 
  site: PropTypes.object, 
  SitesStore: PropTypes.object, 
  TeamsStore: PropTypes.object
};

Record.defaultProps = {
  onClose: ()=> {}, 
  site: {}, 
  SitesStore: {}, 
  TeamsStore: {}
};

export default inject("TeamsStore", "SitesStore")(observer(Record));